<template lang="html">
  <v-card>
    <v-card-title>
      <h3 class="headline mb-0">{{ $tc('label.workflow', 1) }}</h3>
      <div class="flex-grow-1"></div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
            id="workflow-botao-ativar-inativar"
            v-show="canEdit && selected.length > 0"
            class="pt-4 mr-5"
            v-on="on"
            @click="ativarDesativarRegistros">
            <v-icon>block</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('label.ativar_inativa') }}</span>
      </v-tooltip>
      <v-row justify="start" align="center">
        <v-col cols="12" sm="4" md="2" class="mt-5">
          <v-select
            :items="statusOptions"
            item-text="text"
            item-value="value"
            v-model="statusFilter"
            label=""
            dense
            hide-details
            @change="handleStatusFilterChange"
            :menu-props="{ offsetY: true }"/>
        </v-col>
        <v-text-field
          v-model="searchQuery"
          @input="filtrar"
          append-icon="search"
          :label="$t('label.pesquisar')"
          single-line
          clearable
          hide-details/>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="fluxos"
      v-model="selected"
      show-select
      :options.sync="pagination"
      :server-items-length="totalPage"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
      }">
      <template v-slot:item.acoes="{ item }" v-if="canEdit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="mx-0" v-on="on" @click.stop="editarItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('label.editar_produto') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.tipoFluxo="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.tipoFluxo}}
        </span>
      </template>
      <template v-slot:item.descricao="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.descricao}}
        </span>
      </template>
      <template v-slot:item.ind_ativo="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{ item.indAtivo ? $t('label.sim') : $t('label.nao')}}
        </span>
      </template>
      <template v-slot:item.usuarioCriacao="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.usuarioCriacao}}
        </span>
      </template>
      <template v-slot:item.dtaCriacao="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.dtaCriacao}}
        </span>
      </template>
      <template v-slot:item.usuarioAlteracao="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.usuarioAlteracao}}
        </span>
      </template>
      <template v-slot:item.dtaAlteracao="{ item }">
        <span :class="{ 'row--disabled': !item.indAtivo }">
          {{item.dtaAlteracao}}
        </span>
      </template>
    </v-data-table>
  </v-card>
</template>
<script type="text/javascript">
import { generateComputed } from '../../common/functions/roles-computed-generator';

export default {
  data() {
    return {
      resource: this.$api.fluxoAprovacao(this.$resource),
      esperar: false,
      headers: [
        {
          text: '', value: 'acoes', width: '2%', sortable: false,
        },
        { text: this.$tc('label.nome', 1), value: 'tipoFluxo', sortable: false },
        { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: true },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true },
        { text: this.$tc('label.criador', 1), value: 'usuarioCriacao', sortable: false },
        { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false },
        { text: this.$tc('label.atualizador', 1), value: 'usuarioAlteracao', sortable: false },
        { text: this.$tc('label.data_atualizacao', 1), value: 'dtaAlteracao', sortable: false },
      ],
      fluxos: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      totalPage: 0,
      searchQuery: null,
      selected: [],
      timeout: 0,
      statusFilter: this.statusFilterProp != null ? this.statusFilterProp : 'true',
      statusOptions: [
        { text: this.$t('label.todos'), value: '' },
        { text: this.$t('label.ativos'), value: 'true' },
        { text: this.$t('label.inativos'), value: 'false' },
      ],
    };
  },
  props: {
    title: String,
    statusFilterProp: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...generateComputed('fluxo', ['canEdit']),
  },
  watch: {
    pagination: {
      handler() {
        this.buscar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
    statusFilterProp: {
      handler(newValue) {
        if (newValue !== this.statusFilter) {
          this.statusFilter = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    buscar() {
      const params = {
        descricao: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0] ? this.pagination.sortBy[0] : 'tipo_fluxo, descricao',
      };
      if (this.statusFilter !== '') {
        const boolVal = this.statusFilter === 'true';
        params.indAtivo = boolVal;
        params.indAtivoPresente = true;
      }

      this.resource.listar(params).then((response) => {
        this.fluxos = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    ativarDesativarRegistros() {
      const promises = this.selected.map((fluxo) => {
        const { indAtivo, id } = fluxo;
        if (indAtivo) {
          return this.resource.inativar({ id }, { id });
        }
        return this.resource.ativar({ id }, { id });
      });

      Promise.all(promises)
        .then(() => {
          this.selected = [];
          this.buscar();
          this.$toast(this.$t('message.alteracao_massa_sucesso'));
        })
        .catch(() => {
          this.selected = [];
          this.buscar();
          this.$toast(this.$t('errors.ativacao.massa'));
        });
    },
    handleStatusFilterChange() {
      if (this.pagination) {
        this.pagination.page = {};
      }
      this.pagination.page = 1;
      this.filtrar(true);
      this.$emit('STATUS_FILTRO_ALTERADO', this.statusFilter);
    },
    filtrar(trocaPagina) {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar(trocaPagina);
      }, 5E2);
    },
    editarItem(row) {
      this.$emit('WORKFLOWTABLE_EDIT', row);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
  },
  mounted() {
    if (this.statusFilter == null || this.statusFilter === '') {
      this.statusFilter = 'true';
    }
    if (!this.pagination || !this.pagination.page) {
      this.pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        ...(this.pagination || {}),
      };
    }
    this.filtrar(false);
  },
};
</script>
